import gql from 'graphql-tag'

const GET_BID_COUNTRIES = gql`
  query bidCountries($tenantId: Int!, $offset: Int, $limit: Int) {
    bidCountries(tenantId: $tenantId, offset: $offset, limit: $limit) {
      total
      data {
        id
        country
      }
    }
  }
`

export { GET_BID_COUNTRIES }
